import { Link } from 'react-router-dom';
import { categories } from '@/mocks/news';

const categoryImages: Record<string, string> = {
  'wanghong-baoliao': 'https://readdy.ai/api/search-image?query=Dramatic%20social%20media%20influencer%20concept%20with%20dark%20mysterious%20lighting%2C%20editorial%20photography%2C%20warm%20amber%20tones%2C%20breaking%20news%20atmosphere%2C%20social%20media%20icons%20glowing%20in%20darkness%2C%20cinematic%20composition%2C%20professional%20lighting&width=600&height=600&seq=cat-wanghong&orientation=squarish',
  'yule-quan': 'https://readdy.ai/api/search-image?query=Entertainment%20industry%20dramatic%20scene%20with%20spotlight%20on%20stage%2C%20dark%20theater%20atmosphere%2C%20editorial%20photography%2C%20warm%20golden%20and%20deep%20brown%20tones%2C%20cinematic%20mood%2C%20red%20carpet%20concept%2C%20professional%20composition&width=600&height=600&seq=cat-yule&orientation=squarish',
  'zhibo-quan': 'https://readdy.ai/api/search-image?query=Live%20streaming%20setup%20with%20dramatic%20neon%20lighting%2C%20gaming%20chair%20in%20spotlight%2C%20dark%20mysterious%20atmosphere%2C%20editorial%20photography%2C%20warm%20red%20and%20blue%20tones%2C%20streamer%20concept%2C%20cinematic%20composition&width=600&height=600&seq=cat-zhibo&orientation=squarish',
  'zhubo-bagua': 'https://readdy.ai/api/search-image?query=Podcast%20microphone%20in%20dramatic%20spotlight%2C%20dark%20studio%20atmosphere%2C%20editorial%20photography%2C%20warm%20amber%20and%20charcoal%20tones%2C%20broadcasting%20concept%2C%20cinematic%20mood%2C%20professional%20composition&width=600&height=600&seq=cat-zhubo&orientation=squarish',
  'zongyi-chigua': 'https://readdy.ai/api/search-image?query=Television%20studio%20stage%20with%20dramatic%20lighting%2C%20reality%20show%20set%20design%2C%20dark%20atmosphere%2C%20editorial%20photography%2C%20warm%20golden%20and%20deep%20brown%20tones%2C%20cinematic%20composition%2C%20professional%20production&width=600&height=600&seq=cat-zongyi&orientation=squarish',
  'shehui-redian': 'https://readdy.ai/api/search-image?query=Urban%20news%20scene%20with%20dramatic%20city%20lighting%2C%20dark%20atmosphere%2C%20editorial%20photography%2C%20warm%20amber%20and%20deep%20charcoal%20tones%2C%20breaking%20news%20concept%2C%20cinematic%20mood%2C%20professional%20composition&width=600&height=600&seq=cat-shehui&orientation=squarish',
};

export default function CategoryGrid() {
  const displayCategories = categories;

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
            热门分类
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按分类浏览你最感兴趣的爆料内容，吃瓜不迷路
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative aspect-square rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={categoryImages[cat.slug]}
                alt={cat.name}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/20 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-4">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-accent-500/90 rounded-full mb-3">
                  <i className={`${cat.icon} text-xl md:text-2xl text-background-50`}></i>
                </div>
                <h3 className="text-lg md:text-xl font-bold font-heading text-background-50 mb-1">
                  {cat.name}
                </h3>
                <p className="text-xs md:text-sm text-background-200/80">
                  {cat.description}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}